export enum Roles {
  SUPERADMIN = 'ROLE_SUPERADMIN',
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
  CLIENT_ADMIN = 'ROLE_CLIENT_ADMIN',
  FIRE_FIGHTER = 'ROLE_FIRE_FIGHTER',
  SUPERVISOR = 'ROLE_SUPERVISOR',
}
